export enum CheckboxIconType {
  NotSelected,
  Selected,
  Correct,
  Incorrect,
  CorrectNotSelected,
}

/** Returns an icon type to be displayed for an option according to the given state of the component. */
export const calculateCheckboxIcon = (
  wasSubmitPerformed: boolean,
  isSelected: boolean,
  isCorrect: boolean,
  hasMultipleAnswers: boolean,
  revealCorrectAnswers: boolean
): CheckboxIconType => {
  if (!wasSubmitPerformed) {
    return isSelected ? CheckboxIconType.Selected : CheckboxIconType.NotSelected;
  }

  if (!isSelected) {
    if (isCorrect && revealCorrectAnswers) {
      if (hasMultipleAnswers) {
        return CheckboxIconType.CorrectNotSelected;
      }
      return CheckboxIconType.Correct;
    }
    return CheckboxIconType.NotSelected;
  }

  return isCorrect ? CheckboxIconType.Correct : CheckboxIconType.Incorrect;
};

/** Returns a new set of options that are selected by the student. */
export const optionWithIdGotSelected = (
  selectedOptionId: number,
  currentlySelectedOptions: Set<number>,
  isMultipleResponseMode: boolean
) => {
  if (!isMultipleResponseMode) {
    return new Set<number>([selectedOptionId]);
  }

  const newSet = new Set<number>(currentlySelectedOptions);
  if (!newSet.delete(selectedOptionId)) {
    newSet.add(selectedOptionId);
  }

  return newSet;
};
